import { ShaftTippingFraction, Digit, Fraction } from '@/api/models';
export interface ShaftTippingDigitFraction {
  shaftTippingDigitId: number;
  digit: string;
  shaftTippingFractionId: number;
  fraction: string;
  name: string;
}

export const createCombinedShaftTippingDigitFractionList = (joinTableFractions: ShaftTippingFraction[], sourceTabledigits: Digit[], sourceTableFractions: Fraction[]) => {
  let joinTableDigits = ['0', '1', '2', '3'];
  let shaftTippingDigitFractionList = [] as ShaftTippingDigitFraction[];

  joinTableDigits.forEach((joinDigit) => {
    joinTableFractions.forEach((joinFraction) => {
      let digit = sourceTabledigits.find((d) => d.name == joinDigit)?.name || '';
      let fraction = sourceTableFractions.find((f) => f.fractionId == joinFraction.fractionId)?.name || '';
      shaftTippingDigitFractionList.push({
        shaftTippingDigitId: Number(joinDigit),
        digit: joinDigit,
        shaftTippingFractionId: joinFraction.fractionId,
        fraction: fraction,
        name: `${digit} ${fraction}`,
      });
    });
  });

  return shaftTippingDigitFractionList;
};
